import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { colorAttributes, marginAttributes, textAlignmentAttributes, propsBlocker, getComponentOverride } from '../../system';

var getRootBaseStyle = function getRootBaseStyle(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      Typography = _ref.theme.componentOverrides.Typography;

  if (error && disabled) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", " ", "\n        "])), Typography.Root.base, Typography.Root.error__disabled);
  }

  if (error) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", " ", "\n        "])), Typography.Root.base, Typography.Root.error);
  }

  if (disabled) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", " ", "\n        "])), Typography.Root.base, Typography.Root.disabled);
  }

  return Typography.Root.base;
};

var getRootDynamicStyle = function getRootDynamicStyle(_ref2) {
  var theme = _ref2.theme,
      pageTitle = _ref2.pageTitle,
      sectionTitle = _ref2.sectionTitle,
      subSectionTitle = _ref2.subSectionTitle,
      label = _ref2.label,
      paragraph = _ref2.paragraph,
      medium = _ref2.medium,
      small = _ref2.small,
      large = _ref2.large;
  var Root = theme.componentOverrides.Typography.Root;

  if (pageTitle) {
    return Root.pageTitle;
  }

  if (sectionTitle) {
    return Root.sectionTitle;
  }

  if (subSectionTitle) {
    return Root.subSectionTitle;
  }

  if (label) {
    if (large) {
      return Root.label__large;
    }

    if (medium) {
      return Root.label__medium;
    }

    if (small) {
      return Root.label__small;
    }

    return Root.label__medium;
  }

  if (paragraph) {
    if (large) {
      return Root.paragraph__large;
    }

    if (medium) {
      return Root.paragraph__medium;
    }

    if (small) {
      return Root.paragraph__small;
    }

    return Root.paragraph__medium;
  }

  return {};
};

var getMaxLinesStyle = function getMaxLinesStyle(_ref3) {
  var maxLines = _ref3.maxLines;

  if (typeof maxLines !== 'undefined') {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            max-height: calc(var(--typography--line-height) * ", ");\n            overflow-y: hidden;\n        "])), maxLines);
  }

  return '';
};

var Wrapper = function Wrapper(_ref4) {
  var children = _ref4.children,
      restProps = _objectWithoutProperties(_ref4, _excluded);

  return children(_objectSpread({}, restProps));
};

export var TypographyRoot = styled(Wrapper).withConfig(propsBlocker)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), getRootBaseStyle, getRootDynamicStyle, getMaxLinesStyle, getComponentOverride('Typography'), marginAttributes, colorAttributes, textAlignmentAttributes);